import { jsx as w } from "react/jsx-runtime";
import { useCurrentEditor as E } from "../../node_modules/@tiptap/react/dist/index.mjs";
import h, { useRef as i, useEffect as R } from "react";
import { createPortal as x } from "react-dom";
import { twMerge as B } from "tailwind-merge";
import { BubbleMenuPlugin as N } from "./bubble-menu-plugin.mjs";
const z = h.forwardRef(
  ({
    pluginKey: s = "bubbleMenu",
    editor: l,
    updateDelay: c = 0,
    resizeDelay: d,
    appendTo: m,
    shouldShow: b = null,
    getReferencedVirtualElement: a,
    options: f,
    children: p,
    className: g,
    ...P
  }, t) => {
    const n = i(document.createElement("div"));
    typeof t == "function" ? t(n.current) : t && (t.current = n.current);
    const { editor: y } = E(), e = l || y, u = {
      updateDelay: c,
      resizeDelay: d,
      appendTo: m,
      pluginKey: s,
      shouldShow: b,
      getReferencedVirtualElement: a,
      options: {
        placement: "bottom",
        offset: 10,
        ...f
      }
    }, o = i(u);
    return o.current = u, R(() => {
      if (e != null && e.isDestroyed)
        return;
      if (!e) {
        console.warn(
          "BubbleMenu component is not rendered inside of an editor component or does not have editor prop."
        );
        return;
      }
      const r = n.current;
      r.style.visibility = "hidden", r.style.position = "absolute";
      const M = N({
        ...o.current,
        editor: e,
        element: r
      });
      e.registerPlugin(M);
      const v = o.current.pluginKey;
      return () => {
        e.unregisterPlugin(v), window.requestAnimationFrame(() => {
          r.parentNode && r.parentNode.removeChild(r);
        });
      };
    }, [e]), x(
      /* @__PURE__ */ w(
        "div",
        {
          className: B(
            "bg-background-secondary shadow-3xl relative z-20 rounded-lg",
            g
          ),
          ...P,
          children: p
        }
      ),
      n.current
    );
  }
);
export {
  z as BubbleMenu
};
